import React from 'react';
import {
  CategoryRecord,
  ArticlesForCategoryQuery,
  ArticlesForCategoryDocument
} from '~/config/generated/graphql';
import { ArticleCardListBlock } from './ArticleCardListBlock';
import { useCmsData } from '~/App/shared/hooks/useCmsData';
import { BlogArticlesForCategory } from '~/App/shared/interfaces/store/CmsData';

type ArticlesFromCategoryProps = {
  category: Partial<CategoryRecord>;
  articlesLimit?: number;
};

export const ArticlesFromCategory = ({
  category,
  articlesLimit
}: ArticlesFromCategoryProps) => {
  const { data, fetching } = useCmsData<
    ArticlesForCategoryQuery,
    BlogArticlesForCategory
  >({
    storeKey: 'blogArticlesForCategory',
    query: ArticlesForCategoryDocument,
    storeNestedKey: `categoryId-${category.id}`,
    options: {
      variables: { categoryId: category.id }
    }
  });

  return (
    <ArticleCardListBlock
      heading={category.name ?? ''}
      categorySlug={category.slug ?? ''}
      articles={data?.allArticles}
      articlesLimit={articlesLimit}
      isLoading={fetching}
    />
  );
};

export default ArticlesFromCategory;
